import { Component, OnInit } from '@angular/core';
import {
  ProductWhereToShopListResponse,
  ProductWhereToShopListResponseCategory,
} from 'src/app/api/client/models';
import { WhereToShopService } from 'src/app/api/client/services';

@Component({
  selector: 'app-featured-where-to-shop',
  templateUrl: './featured-where-to-shop.component.html',
  styleUrls: ['./featured-where-to-shop.component.scss'],
})
export class FeaturedWhereToShopComponent implements OnInit {
  constructor(private api: WhereToShopService) {}

  stores: ProductWhereToShopListResponseCategory[] = [];
  public loading = false;

  public response: ProductWhereToShopListResponse | undefined = undefined;

  async ngOnInit(): Promise<void> {
    this.response = await this.api
      .v1WhereToShopPost$Json({
        body: {
          featured: true,
          manage: false,
          pageIndex: 0,
          pageSize: 25,
          productId: 'e71fc875f5f644b79a7660d3cbaf3c04',
        },
      })
      .toPromise();

    if (this.response.categories) {
      this.stores = [...this.response.categories!];
    }
  }

  async click(placementId: string, url: string) {
    window.open(url, '_blank');
    await this.api
      .v1WhereToShopClickPost({
        body: {
          placementId: placementId,
        },
      })
      .toPromise();
  }
}
